/* Healthy Stars · PDP */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var f = function (n) { return 'Q' + (Math.abs(n - Math.round(n)) < 0.005 ? Math.round(n) : n.toFixed(2)); };
  var arrow = '<svg class="ic"><use href="#i-arrow"/></svg>';

  /* galería */
  function show(btn) {
    $$('#thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === btn); });
    var box = $('#mainBox'), v = $('#mainVid'), i = $('#mainImg');
    if (!box) return;
    if (btn.dataset.video) {
      if (v.getAttribute('src') !== btn.dataset.video) { v.poster = btn.dataset.poster; v.src = btn.dataset.video; }
      box.classList.add('is-video'); v.play().catch(function () {}); return;
    }
    v.pause(); box.classList.remove('is-video'); i.style.opacity = .2;
    setTimeout(function () { i.src = btn.dataset.src; i.style.opacity = 1; }, 120);
  }
  $$('#thumbs button').forEach(function (b) { b.onclick = function () { show(b); }; });

  /* agregar al carrito */
  function addToCart(items, after) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { location.href = after === 'cart' ? '/cart' : '/checkout'; });
  }

  /* caja de compra */
  var cfgEl = $('#hsCfg');
  if (cfgEl) {
    var C = JSON.parse(cfgEl.textContent), A = C.addon, S = { mode: 'sub', qty: 1, add: false };
    var tot = function (m, q) { return C[m][q] + (S.add && A ? A[m] : 0); };
    var unit = function (q) { return C.unit[q] + (S.add && A ? ' + ' + A.unit : ''); };
    var per = function (n, q) { return f(n / (30 * q)) + (q > 1 ? ' al día por persona' : ' al día'); };
    var b = $('#buy'), apps = $('#hsApps');
    var tr = $('#trial'), fe = $('.hs-pdp .first'), firstTx = fe ? fe.textContent.trim().replace('en la compra única ', '') : '';
    var render = function () {
      var q = S.qty, one = tot('one', q), sub = tot('sub', q);
      var save2 = C.one[1] * 2 - C.one[2];
      if ($('#tag2')) $('#tag2').textContent = 'Ahorra ' + f(save2);
      var oneRef = q > 1 ? C.one[1] * q + (S.add && A ? A.reg : 0) : (S.add && A ? C.one[1] + A.reg : 0);
      $('#subMeta').textContent = unit(q) + ' cada mes';
      $('#subWas').textContent = f(one); $('#subNow').textContent = f(sub); $('#subDay').textContent = per(sub, q);
      $('#hbS').textContent = f(one - sub);
      $('#oneWas').textContent = oneRef > one ? f(oneRef) : ''; $('#oneNow').textContent = f(one); $('#oneDay').textContent = per(one, q);
      if (A && $('#addPr')) {
        $('#addPr').innerHTML = '+' + f(A[S.mode]) + (A.reg > A[S.mode] ? '<s>' + f(A.reg) + '</s>' : '');
        var box = $('#addBox'), inp = $('#addOn');
        box.classList.toggle('off', q > 1); inp.disabled = q > 1;
        if (q > 1 && S.add) { S.add = false; inp.checked = false; return render(); }
      }
      var qty = $('#hsQty'); if (qty) qty.value = q * C.upp;
      if (S.mode === 'sub') {
        b.innerHTML = 'Empezar mi suscripción ' + arrow;
        $('#renew').textContent = f(sub) + ' cada mes · pausa o cancela por WhatsApp';
        if (tr) tr.hidden = true; if (apps) apps.hidden = true;
        $('#stP').textContent = f(sub); $('#stS').textContent = 'Suscripción · ahorras ' + f(one - sub) + ' al mes · envío gratis';
      } else {
        b.innerHTML = 'Comprar ahora ' + arrow;
        $('#renew').textContent = firstTx || 'Pagas al recibir o con tarjeta';
        if (tr) tr.hidden = false; if (apps) apps.hidden = false;
        $('#stP').textContent = f(one); $('#stS').textContent = 'Compra única · envío gratis';
      }
    };
    var pick = function (g, v, sel) { $$(g + ' ' + sel).forEach(function (o) { o.setAttribute('aria-checked', o.dataset.v === String(v)); }); };
    $$('#plans .plan').forEach(function (o) {
      var go = function () { S.mode = o.dataset.v; pick('#plans', S.mode, '.plan'); render(); };
      o.onclick = go; o.onkeydown = function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } };
    });
    $$('#qty .opt').forEach(function (o) { o.onclick = function () { S.qty = +o.dataset.v; pick('#qty', S.qty, '.opt'); render(); }; });
    var ad = $('#addOn'); if (ad) ad.onchange = function () { S.add = ad.checked; render(); };
    b.addEventListener('click', function () {
      if (S.mode === 'sub') {
        var key = S.qty + (S.add ? '+' : '');
        if (window.hsSuscripcion) window.hsSuscripcion.open(C.plans[key]);
        return;
      }
      var items = [{ id: C.variant, quantity: S.qty * C.upp }];
      if (S.add && A) items.push({ id: A.variant, quantity: 1 });
      b.disabled = true; b.innerHTML = 'Agregando…';
      addToCart(items, C.cartAfter).catch(function () { b.disabled = false; render(); alertBox('No pudimos agregarlo. Intenta de nuevo o escríbenos por WhatsApp.'); });
    });
    if (tr) tr.onclick = function () { tr.disabled = true; addToCart([{ id: C.variant, quantity: 1 }], C.cartAfter).catch(function () { tr.disabled = false; }); };
    var alertBox = function (m) { var r = $('#renew'); if (r) r.textContent = m; };
    render();

    /* barra fija */
    var st = $('#sticky'), card = $('#comprar');
    if (st && card && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { st.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(card);
    }
  }

  /* productos complementarios */
  $$('.hs-pdp [data-add]').forEach(function (x) {
    x.onclick = function () { x.disabled = true; addToCart([{ id: +x.dataset.add, quantity: 1 }], 'cart').catch(function () { x.disabled = false; }); };
  });

  /* videos */
  $$('.hs-pdp .ugc').forEach(function (sec) {
    var row = $('.uRow', sec); if (!row) return;
    var figs = [].slice.call(row.children), dots = $('.uDots', sec);
    figs.forEach(function () { dots.appendChild(document.createElement('i')); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting && e.intersectionRatio > .6) { if (!v.src) v.src = v.dataset.src; v.play().catch(function () {}); } else v.pause(); }); }, { threshold: [0, .6, 1] });
    $$('video', row).forEach(function (v) { io.observe(v); });
    $$('.snd', row).forEach(function (bt) {
      bt.onclick = function () {
        var v = bt.parentNode.querySelector('video'), on = v.muted;
        $$('video', row).forEach(function (x) { x.muted = true; });
        v.muted = !on; bt.querySelector('.w').style.display = on ? 'none' : '';
        bt.setAttribute('aria-label', on ? 'Silenciar' : 'Activar sonido'); if (on) v.play().catch(function () {});
      };
    });
    var step = function () { return figs[0].getBoundingClientRect().width + 12; };
    $('.uPrev', sec).onclick = function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); };
    $('.uNext', sec).onclick = function () { row.scrollBy({ left: step(), behavior: 'smooth' }); };
    var upd = function () {
      if (!figs.length) return;
      var i = Math.round(row.scrollLeft / step());
      [].forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === i); });
      $('.uPrev', sec).disabled = row.scrollLeft < 4; $('.uNext', sec).disabled = row.scrollLeft + row.clientWidth > row.scrollWidth - 4;
      var fit = row.scrollWidth <= row.clientWidth + 4; dots.style.visibility = fit ? 'hidden' : ''; $('.nav', sec).style.visibility = fit ? 'hidden' : '';
    };
    row.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  });
  var bv = $('.hs-pdp .band video');
  if (bv) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { if (!bv.getAttribute('src') && bv.dataset.src) bv.src = bv.dataset.src; bv.play().catch(function () {}); } else bv.pause(); }); }).observe(bv);

  /* tabla nutricional */
  var nd = $('#nutriData');
  if (nd) {
    var D = JSON.parse(nd.textContent), md = $('#ntMd'), ov = $('#ntOv'), mult = 1;
    $('#ntBrand').textContent = D.brand; $('#ntT').textContent = D.title;
    $('#ntSv').innerHTML = D.serving.map(function (x) { return '<div>' + x + '</div>'; }).join('');
    $('#ntImg').src = nd.dataset.img || D.img || '';
    var sc = function (a, m) { return m === 1 ? a : a.replace(/([\d.,]+)/, function (n) { var v = parseFloat(n.replace(/\./g, '').replace(',', '.')) * m; var r = Math.round(v * 10) / 10; var p = String(r).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (p[1] && r < 100 ? ',' + p[1] : ''); }); };
    var opts = D.multi || [];
    $('#ntCalc').innerHTML = opts.length ? '<span>Ver cantidades:</span>' + opts.map(function (o, i) { return '<button type="button" aria-pressed="' + (i === 0) + '" data-m="' + o.m + '">' + o.l + '</button>'; }).join('') : '';
    var rows = function () {
      $('#ntRows').innerHTML = D.rows.map(function (r) {
        return '<div class="nt-r' + (r.sep ? ' sep' : '') + '"><button type="button" aria-expanded="false"><span class="nt-n"><span class="nt-chev">' + (r.info ? '+' : '') + '</span>' + r.n + '</span><span class="nt-a">' + sc(r.a || '', mult) + '</span><span class="nt-d">' + (mult === 1 ? (r.d || '') : (r.d && /%/.test(r.d) ? '' : r.d || '')) + '</span></button>' + (r.sub ? '<div class="nt-sub">' + r.sub.join(', ') + '</div>' : '') + (r.info ? '<div class="nt-info">' + r.info + '</div>' : '') + '</div>';
      }).join('');
      $$('#ntRows .nt-r').forEach(function (el) { var bt = el.querySelector('button'); if (!el.querySelector('.nt-info')) return; bt.onclick = function () { var o = el.classList.toggle('open'); bt.setAttribute('aria-expanded', o); }; });
    };
    rows();
    $('#ntNotes').innerHTML = D.notes.map(function (x) { return '<div>' + x + '</div>'; }).join('');
    $$('#ntCalc button').forEach(function (bt) { bt.onclick = function () { mult = +bt.dataset.m; $$('#ntCalc button').forEach(function (x) { x.setAttribute('aria-pressed', x === bt); }); rows(); }; });
    $('#ntIn').innerHTML = D.info.map(function (kv) { return '<div><dt>' + kv[0] + '</dt><dd>' + kv[1] + '</dd></div>'; }).join('');
    $$('.nt-tabs button').forEach(function (bt) { bt.onclick = function () { $$('.nt-tabs button').forEach(function (x) { x.setAttribute('aria-selected', x === bt); }); $$('.nt-p').forEach(function (p) { p.hidden = p.dataset.p !== bt.dataset.t; }); }; });
    var last;
    var open = function () { last = document.activeElement; md.hidden = ov.hidden = false; document.body.style.overflow = 'hidden'; $('#ntX').focus(); };
    var close = function () { md.hidden = ov.hidden = true; document.body.style.overflow = ''; if (last) last.focus(); };
    $('#ntX').onclick = close; ov.onclick = close;
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !md.hidden) close(); });
    var lab = $('#lab'); if (lab) lab.onclick = open;
  }
})();
